import { Box } from '@mui/material';
import { FC } from 'react';
import { object, string } from 'yup';
import Drawer from '..';
import DrawerContent from '../content';
import DrawerHeader from '../header';
import { DrawerProps } from '../helpers';
import useFormHandle from '@/hooks/use-form-handle.hook';
import InputControl from '@/components/form/input-control';
import { Form } from '@/components/form';
import DrawerButtons from '@/components/form/drawer-buttons';

interface Props extends DrawerProps {
  title?: string;
  content: string;
  onSubmit: (values: { name: string }) => void;
}

export const NewWithNameDrawer: FC<Props> = ({
  title = 'Confirm',
  content,
  onSubmit,
  open,
  onClose,
  className,
}) => {
  const formHandle = useFormHandle({
    initialValues: { name: '' },
    validationSchema: object({ name: string().required('Name is required') }),
    onSubmit: (values, { setSubmitting, resetForm }) => {
      resetForm({ values });
      onSubmit(values);
      setSubmitting(false);
    },
  });

  const { handleSubmit, canSubmit, isSubmitting } = formHandle;

  const handleCancel = () => {
    onClose();
  };

  return (
    <Drawer open={open} onClose={onClose} className={className} size="small">
      <DrawerHeader onClose={onClose} hideMenu>
        {title}
      </DrawerHeader>
      <DrawerContent>
        <Box mt={2}>
          <Box>{content}</Box>
          <Form formHandle={formHandle}>
            <InputControl name="name" label="Name" formHandle={formHandle} autoFocus />
          </Form>

          <DrawerButtons
            submit
            cancel
            isNew
            canSubmit={canSubmit}
            canCancel={!isSubmitting}
            onSubmit={handleSubmit}
            onCancel={handleCancel}
            formHandle={formHandle}
          />
        </Box>
      </DrawerContent>
    </Drawer>
  );
};

export default NewWithNameDrawer;
